import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const TermsLazy = lazyLoader(
  () => import('./Terms' /* webpackChunkName: "terms-conditions" */),
);

const Terms = () => {
  return (
    <Suspense fallback={null}>
      <TermsLazy />
    </Suspense>
  );
};

export default Terms;
